import api from './client'

/**
 * Traducciones del contenido de la tienda (banners, carrusel, experiencias):
 * las arma la IA al guardar; acá se ven y se corrigen.
 */
export const traduccionesApi = {
  listar: (q = '') => api.get('/web/traducciones', { params: q ? { q } : {} }),
  corregir: (id, texto) => api.put(`/web/traducciones/${id}`, { texto }),
  traducirPendientes: () => api.post('/web/traducciones/traducir'),
}
